/**
 * Form reducer.
 * This reducer is prepopulated on the server based on post data.
 * @module reducers/form/form
 */

const initialState = {};

/**
 * Form reducer.
 * @function form
 * @param {Object} state Current state.
 * @returns {Object} New state.
 */
export default function form(state = initialState) {
  return state;
}
